// @flow

import React, { Component } from 'react';
import { Button } from 'reactstrap';

type PropsType = {
    imageUrl: string,
    onRemoveClick: () => void,
};

class RemovableImage extends Component<PropsType> {
    render() {
        return (
            <div onClick={() => this.props.onRemoveClick()} className="removable-image-container">
                <img src={this.props.imageUrl} className="removable-image-image" alt="" />
                <Button className="removable-image-button">Remove</Button>
            </div>
        );
    }
}

export default RemovableImage;
